export default __webpack_public_path__ + "static/media/019-Santa Claus.31c46bd5.svg";